export default __webpack_public_path__ + "static/media/cloud_off.427fc71f.svg";